import { createSelector } from '@reduxjs/toolkit';
import { EWCType } from '../../../../packages/api-models/common/json_query';
import { selectBathroomType } from 'shared/selectors/jsonQuery';
import { selectBathroomCountFilter } from './selectBathroomCountFilter';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Совмещённый', value: EWCType.United },
  { label: 'Раздельный', value: EWCType.Separated },
];

export const selectUrbanBathroomFilter = createSelector(
  [selectBathroomType, selectBathroomCountFilter],
  (value, bathroomCountFilter) => ({
    label: 'Санузел',
    value: [value],
    options: OPTIONS,
    bathroomCountFilter,
  }),
);
